import React from "react";

const OutputDetails = ({ outputDetails }) => {
  return (
    <div className="metrics-container">
      <p className="text-sm">
        Status:{" "}
        <span >
          {outputDetails?.status?.description}
        </span>,
        Memory:{" "}
        <span >
          {outputDetails?.memory}
        </span>,
        Time:{" "}
        <span>
          {outputDetails?.time}
        </span>
      </p>
    </div>
  );
};

export default OutputDetails;
